import { render, staticRenderFns } from "./mobile_spot_inquiry_detail.vue?vue&type=template&id=489fa0b3&scoped=true&"
import script from "./mobile_spot_inquiry_detail.vue?vue&type=script&lang=js&"
export * from "./mobile_spot_inquiry_detail.vue?vue&type=script&lang=js&"
import style0 from "./mobile_spot_inquiry_detail.vue?vue&type=style&index=0&id=489fa0b3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "489fa0b3",
  null
  
)

export default component.exports